import Vue from 'vue'
import VueRouter from 'vue-router'
import iView from 'iview';
import ElementUI from 'element-ui'
import Vuex from 'vuex'
import store from '../store/index.js'
const Home = resolve => require(['../page/Home/home'], resolve)
const Fintech = resolve => require(['../page/fintech/index'], resolve)
const Msg = resolve => require(['../page/message/message'], resolve)
const Detail = resolve => require(['../page/message/detail'], resolve)
const Intro = resolve => require(['../page/about/intro'], resolve)
const Join = resolve => require(['../page/join/list'], resolve)
const Wish = resolve => require(['../page/loan/wishloan'], resolve)
const Login = resolve => require(['../page/login/index'], resolve)
const Unknow  = resolve => require(['../page/404/404.vue'], resolve)

const Tuisong = resolve => require(['../page/tuisong/business'], resolve)
const Tuisong1 = resolve => require(['../page/tuisong/businessDAY'], resolve)
const Tuisong2 = resolve => require(['../page/tuisong/manage'], resolve)
const Tuisong3 = resolve => require(['../page/tuisong/guaranteeRmind'], resolve)
const AnalysisPage = resolve => require(['../page/tuisong/analysis'], resolve)

// 我的账户
const Account = resolve => require(['../page/account/mine'], resolve)
const AccoungIndex  = resolve => require(['../page/account/index.vue'], resolve)
const AuthManage  = resolve => require(['../page/account/authManage.vue'], resolve)
const CompanyInfo  = resolve => require(['../page/account/companyInfo.vue'], resolve)
const LoanManage  = resolve => require(['../page/account/loanManage.vue'], resolve)
const bankCardManage  = resolve => require(['../page/account/bankCardManage.vue'], resolve)
const SignManage  = resolve => require(['../page/account/signManage.vue'], resolve)
const LoanApply  = resolve => require(['../page/account/loanApply.vue'], resolve)


Vue.use(VueRouter)
Vue.use(iView);
Vue.use(Vuex);


const router = new VueRouter({
  mode: 'history',
    routes: [
      {
        path: '/business',
        component: Tuisong,
        name: 'business',
      },
      {
        path: '/businessDAY',
        component: Tuisong1,
        name: 'businessDAY',
      },
      {
        path: '/manage',
        component: Tuisong2,
        name: 'manage',
      },
      {
        path: '/guaranteeRmind',
        component: Tuisong3,
        name: 'guaranteeRmind',
      },
      {
        path: '/projects',
        component: AnalysisPage,
        name: 'Analysis',
      },
        {
          path: '/home',
          component: Home,
          name: 'home',
        },
        {
          path: '/fintech',
          component: Fintech,
          name: 'fintech',
        },
        {
          path: '/info',
          component: Msg,
          name: 'msg',
        },
        {
          path: '/intro',
          component: Intro,
          name: 'intro',
        },
        {
          path: '/account/AccoungIndex',
          component: Account,
          name: 'account',
          children: [
            {
              path: '/account/AccoungIndex',
              component: AccoungIndex,
              name: 'accoungIndex',
            },
            {
              path: '/account/companyInfo',
              component: CompanyInfo,
              name: 'companyInfo',
            },
            {
              path: '/account/loanManage',
              component: LoanManage,
              name: 'loanManage',
            },
            {
              path: '/account/authManage',
              component: AuthManage,
              name: 'authManage',
            },
            {
              path: '/account/bankCardManage',
              component: bankCardManage,
              name: 'bankCardManage',
            },
            {
              path: '/account/signManage',
              component: SignManage,
              name: 'signManage',
            },
            {
              path: '/account/loanApply',
              component: LoanApply,
              name: 'LoanApply',
            },
          ]
        },
        {
          path: '/wishloan',
          component: Wish,
          name: 'wish',
        },
        {
          path: '/login',
          component: Login,
          name: 'login',
        },
        { path: '/info/:id', component: Detail },
        {
          path: '/joinUs',
          component: Join,
          name: 'join',
        },
        { path: '*', name: '404', component: Unknow },
        { path: '/', redirect: '/home' },
    ]
})
router.beforeEach((to, from, next) => {
  if(to.path.startsWith('/account/')){
    let userInfo = JSON.parse(window.sessionStorage.getItem('userInfo'));
    if(userInfo){
      next();
    }else{
      router.push('/login')
    }
  }else{
    next()
  }
});
router.afterEach(route => {
    iView.LoadingBar.finish();
});
export default router



// WEBPACK FOOTER //
// ./src/router/index.js